export default __webpack_public_path__ + "static/Figtree-Regular-946f5a5c0b1b3f545150fe3dac319708.woff";